<template>

  <Head>
    <title>iWebStudio-Tech</title>
    <meta name="description" content="We Bring ideas to life" />
  </Head>
  <CodeRainBg />
  <LoadingPage />
  <DsnNavbar />
  <CursorGrowing />
  <AiChatBot />
  <CookieBanner />
  <router-view :key="$route.fullPath" />
</template>

<!-- <script type="text/javascript">
  (function(d, t) {
      var v = d.createElement(t), s = d.getElementsByTagName(t)[0];
      v.onload = function() {
        window.voiceflow.chat.load({
          verify: { projectID: '65c2572765e7726cb37fd049' },
          url: 'https://general-runtime.voiceflow.com',
          versionID: 'production'
        });
      }
      v.src = "https://cdn.voiceflow.com/widget/bundle.mjs"; v.type = "text/javascript"; s.parentNode.insertBefore(v, s);
  })(document, 'script');
</script>-->

<script setup>
import { Head } from "@unhead/vue/components";
import LoadingPage from "@/components/loading/LoadingPage.vue";
import DsnNavbar from "@/components/navbar/DsnNavbar.vue";
import CursorGrowing from "@/components/scroll-and-cursor/CursorGrowing.vue";
import CodeRainBg from "@/components/background/CodeRainBg.vue";
import AiChatBot from "@/components/chatbot/AiChatBot.vue";
import CookieBanner from "@/components/gdpr/CookieBanner.vue";
import { onUpdated } from "vue";
import { cursorGrowing } from "@/assets/global/global"

onUpdated(() => {
  cursorGrowing()
})
</script>

<style>
/* Prevent horizontal scroll on mobile (iOS Safari WebKit fix).
   #app is NOT the scroll container, so overflow-x: hidden is
   reliably respected even when body has overflow-y: auto.
   overscroll-behavior-x: none prevents horizontal bounce/swipe
   even when GSAP-animated elements temporarily exceed clip bounds. */
#app {
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
  overscroll-behavior-x: none;
}
</style>
